<ng-container [ngSwitch]="!!form">
  <app-form-master
    *ngSwitchCase="true"
    [form]="form"
    class="send-form"
    (formChanges)="updateFormData($event)"
  >
    <div class="email-editor">
      <div class="send-header">
        <div class="form-row">
          <ng-container *ngIf="enableRecipientFields">
            <app-email-tag-field
              class="to-field"
              [label]="'LABEL.TO' | translate"
              fieldId="email_to_field"
              [formControl]="form.get(formKeys.TO)"
              [maxRecipientsMessage]="
                'VERIFY_ACCOUNT.ADD_MORE_RECIPIENTS_ALERT' | translate
              "
              [limit]="(maxRecipients$ | async).get('to')"
            >
            </app-email-tag-field>

            <button
              type="button"
              *ngIf="!showCC"
              class="action"
              (click)="toggleCC()"
              trackable
              [trackingObject]="documentTrackingObject"
              [trackingAction]="ccButtonTapped"
            >
              {{ 'LABEL.CC' | translate }}
            </button>

            <button
              type="button"
              *ngIf="!showBCC"
              class="action"
              (click)="toggleBCC()"
              trackable
              [trackingObject]="documentTrackingObject"
              [trackingAction]="bccButtonTapped"
            >
              {{ 'LABEL.BCC' | translate }}
            </button>
          </ng-container>
        </div>

        <app-email-tag-field
          *ngIf="showCC"
          class="cc-field"
          [label]="'LABEL.CC' | translate"
          fieldId="email_cc_field"
          [formControl]="form.get(formKeys.CC)"
          [maxRecipientsMessage]="
            'VERIFY_ACCOUNT.ADD_MORE_RECIPIENTS_ALERT' | translate
          "
          [limit]="(maxRecipients$ | async).get('cc')"
        >
        </app-email-tag-field>

        <app-email-tag-field
          *ngIf="showBCC"
          class="bcc-field"
          [label]="'LABEL.BCC' | translate"
          fieldId="email_bcc_field"
          [formControl]="form.get(formKeys.BCC)"
          [maxRecipientsMessage]="
            'VERIFY_ACCOUNT.ADD_MORE_RECIPIENTS_ALERT' | translate
          "
          [limit]="(maxRecipients$ | async).get('bcc')"
        >
        </app-email-tag-field>

        <div class="form-field-wrapper">
          <app-input-field
            class="subject-field"
            [label]="'LABEL.SUBJECT' | translate"
            fieldId="email_subject_field"
            [fieldControl]="form.get(formKeys.SUBJECT)"
          >
          </app-input-field>

          <div
            *ngIf="disableEmailCustomization"
            class="form-field-mask"
            (click)="showEmailCustomizationDialog()"
          ></div>
        </div>
      </div>

      <div class="send-body">
        <div class="message-form-field-wrapper">
          <i2g-textarea-field
            fieldId="email_body_field"
            class="message-textarea"
            [dynamicResize]="true"
            [placeholder]="'PLACEHOLDER.ENTER_MESSAGE' | translate"
            [fieldControl]="form.get(formKeys.MESSAGE)"
            [readOnly]="disableEmailCustomization"
            [maxlength]="4000"
            [showCounter]="false"
            [errorMessages]="noHtmlAndLinksErrorMessage"
          >
          </i2g-textarea-field>

          <div
            *ngIf="disableEmailCustomization"
            class="form-field-mask"
            (click)="showEmailCustomizationDialog()"
          ></div>
        </div>

        <ng-content></ng-content>
      </div>

      <div class="send-footer">
        <div *ngIf="attachmentName">
          <div
            *ngIf="!enableFileAttachment; else fileAttachmentExperiment"
            class="attachment"
          >
            <app-icon
              class="attachment-icon"
              [icon]="attachmentIcon"
            ></app-icon>

            <div class="attachment-filename">
              {{ attachmentName }}
            </div>
          </div>

          <ng-template #fileAttachmentExperiment>
            <app-file-attachment
              [attachments]="attachments"
              [fileAttachments]="fileAttachments"
              [attachmentName]="attachmentName"
              [attachmentSize]="attachmentSize"
              [documentDataDispatcher]="documentDataDispatcher"
              [trackingScreenName]="trackingScreenName"
              [trackingObject]="documentTrackingObject"
            >
            </app-file-attachment>
          </ng-template>
        </div>

        <div *ngIf="showFooter" class="invoice2go-footer">
          <a class="fake-footer-link" href="javascript:void(0)">
            {{
              'SETTINGS.CLIENT_COMMUNICATION.POWERED_BY_INVOICE2GO' | translate
            }}
          </a>
        </div>
      </div>
    </div>

    <div *ngIf="showFooter" class="footer-toggle">
      <app-toggle-field
        [label]="'EMAIL.INCLUDE_INVOICE2GO_FOOTER' | translate"
        fieldId="include_footer_field"
        [icon]="featureHighlightIcon"
        [fieldControl]="form.get(formKeys.INCLUDE_FOOTER)"
        (onClickIcon)="showFeatureHighlightDialog()"
        [trackingObject]="documentTrackingObject"
        trackingIdentifier="i2g_footer"
        [trackingScreenName]="trackingScreenName"
      >
      </app-toggle-field>
    </div>
  </app-form-master>

  <ng-container *ngSwitchDefault>
    <div
      *ngFor="let i of 2 | fill"
      class="placeholder-email-field shimmer"
    ></div>

    <div class="placeholder-email-contents">
      <div
        *ngFor="let i of 4 | fill; let index = index"
        class="placeholder-email-body body-{{ index + 1 }} shimmer"
      ></div>
    </div>
  </ng-container>
</ng-container>

<app-confirm-dialog
  *ngIf="disableEmailCustomization"
  [dialogId]="disableCustomizeEmailDialogId"
  [confirmTitle]="'DIALOG.CUSTOMIZE_EMAIL.UPGRADE_TO_CUSTOMIZE' | translate"
  [confirmPrompt]="'DIALOG.CUSTOMIZE_EMAIL.CURRENT_PLAN_NO_SUPPORT' | translate"
  [yesText]="'ACTION.UPGRADE' | translate"
  [cancelText]="'ACTION.DISMISS' | translate"
  (onClose)="onDisableEmailCustomizationDialogClose($event)"
>
</app-confirm-dialog>
